import {
	SET_TRIGGERED_ALARMS,
	HIDE_TOAST_MESSAGE,
	SHOW_ERROR_MESSAGE,
	SHOW_SUCCESS_MESSAGE,
	SET_AVAILABLE_ASSETS,
	RESET_STATE,
	CLEAR_FILTERS
} from "./AlarmsActionsType";

import ToastMessageType from "@/constants/enums/ToastMessageType";

export default {
	[SET_TRIGGERED_ALARMS](state, triggeredAlarms)
	{
		state.alarms = triggeredAlarms;
	},

	[HIDE_TOAST_MESSAGE](state)
	{
		setTimeout(() => state.toast.show = false, 3000);
	},

	[SHOW_ERROR_MESSAGE](state, message)
	{
		state.toast.type = ToastMessageType.ERROR;
		state.toast.message = message;
		state.toast.show = true;
	},

	[SHOW_SUCCESS_MESSAGE](state, message)
	{
		state.toast.type = ToastMessageType.SUCCESS;
		state.toast.message = message;
		state.toast.show = true;
	},

	[SET_AVAILABLE_ASSETS](state, assets)
	{
		state.availableAssets = assets;
	},

	[RESET_STATE](state)
	{
		state.alarms = [];
		state.toast = {
			show:    false,
			message: "",
			type:    ToastMessageType.ERROR
		};
		state.assets = [];
		state.statuses = [];
	},
	[CLEAR_FILTERS](state)
	{
		state.selectedAssets = [];
		state.selectedStatus = [];
	},
	SET_METADATA(state, { assets, statuses })
	{
		state.assets = assets;
		state.statuses = statuses;
	},
	SET_TOAST_SHOW(state, value)
	{
		state.toast.show = value;
	}
};
